var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookF = function SvgFacebookF(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.25 12.488V19.8h3.988v-7.312h2.973l.619-3.362h-3.592v-1.19c0-1.776.697-2.457 2.499-2.457.56 0 1.01.014 1.272.041V2.471c-.492-.134-1.695-.271-2.39-.271-3.674 0-5.369 1.736-5.369 5.48v1.446H5.981v3.362z"
  })));
};
export default SvgFacebookF;